// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nfCN","col":"styles_col__2WpbW","actions":"styles_actions__2db7_","conflict":"styles_conflict__2s1W7"};